import type { CSSProperties } from "react";
import {
  resolveSeriesColor,
  seriesLineStyle,
} from "@/constants/chart-palette";

export type ChartField = {
  title: string;
  color?: string;
  hidden?: boolean;
};

export type ChartLine = {
  dataKey: string;
  name: string;
  stroke: string;
  style?: CSSProperties;
};

export function buildLinesFromFields(
  fields: Record<string, ChartField> | undefined,
): { lines: ChartLine[]; defaultHidden: string[] } {
  if (!fields) return { lines: [], defaultHidden: [] };

  const defaultHidden: string[] = [];
  const lines = Object.keys(fields).map((key, index) => {
    if (fields[key]?.hidden) defaultHidden.push(key);
    const stroke = resolveSeriesColor(key, fields[key].title, index);
    return {
      dataKey: key,
      name: fields[key].title,
      stroke,
      style: seriesLineStyle(stroke),
    };
  });

  return { lines, defaultHidden };
}

export { resolveSeriesColor, seriesLineStyle };
